module.exports = __webpack_public_path__ + "img/doctor.14a657ba.png";